/*
# Dependencies
	- mod.js
	- jquery 1.7+
	- mod.modules.js
	- mod.observer.js
*/

(function($, mod) {

	var helpers = {
		_bindEvents: function(events, el, context) {
			var selector, action, handler, selectorsEvents, selectors;
			var nonBubblingEvents = {
				load: true,
				ready: true
			};

			for (initialSelector in events) {
				selectorsEvents = events[initialSelector];
				// Allow selectors to be specified as a comma delimited list
				// e.g., "input, textarea"
				selectors = initialSelector.split(",");

				for (var i = 0; i < selectors.length; i++) {
					selector = $.trim(selectors[i]);

					if (!$.isEmptyObject(selectorsEvents)) {
						for (action in selectorsEvents) {
							handler = selectorsEvents[action];

							// Trigger non-bubbling events immediately
							if (action in nonBubblingEvents) {
								handler.call(context, null, el.find(selector));
							}
							else {
								handler = $.proxy(handler, context);

								// Allow the module to attach an event to the container
								if (selector === "this") {
									el.on(action, handler);
								}
									// Bind events normally
								else {
									el.on(action, selector, handler, context._actionHandler);
								}
							}
						}
					}
					else {
						console.error(context.name + ": no events for '" + selector + "' selector");
					}
				}
			}
		},
		_bindListeners: function(observables, context) {
			for (var action in observables) {
				var handler = observables[action];
				
				if (handler) {
					mod.observer.bind(action, handler, context);

				}
				else {
					console.error(context.name + ": no handler provided for observable '" + action + "'");
				}
			}
		},
		_saveInstanceOnDom: function(el, context) {
			var instances = el.data("widget");

			if (!instances) {
				instances = {
					dispose: function() {
						for (var name in instances) {
							if (name !== "dispose") {
								instances[name].dispose();
							}
						}
					}
				};
			}

			instances[context.name] = context;
			el.data("widget", instances);
		}
	};

	mod.baseModule = function() { };

	mod.baseModule.prototype = {

		// Friendly name
		name: "baseModule",

		// List of all events that will be attached
		events: {},

		// List of all observable listeners
		observables: {},

		// Stand in for the constructor
		init: function(params) { },

		_init: function(el, params) {
			// Add the instance only properties
			this._plugins = [];
			this.el = el;
			this.$el = $(el);

			helpers._bindEvents(this.events, this.el, this);
			helpers._bindListeners(this.observables, this);
			helpers._saveInstanceOnDom(this.el, this);

			this.init(params);

			this.hideLoading();
		},

		addPlugin: function(name, params) {
			var plugin = mod.modules.create(name, this.el, params);
			this._plugins.push(plugin);
			return plugin;
		},

		// Generic handler for all events
		_actionHandler: function(e) {
			var fn = e.data;
			var $target = $(e.currentTarget);
			var proceed = fn(e, $target);

			if (proceed === false) {
				e.preventDefault();
				e.stopPropagation();
			}
		},

		// The prototype this class was extended from
		_parent: null,
		_lastParentContext: null,

		// A convenience function for classes to access their parent prototype
		// DO NOT ALTER THIS FUNCTION UNLESS YOU KNOW EXACTLY WHAT YOU'RE DOING (or even then)
		base: function(fnName, fnArgs) {
			var context = this;
			var isLastContext = (this._lastParentContext == this);

			// Make sure we aren't stuck in an infinite loop
			if (isLastContext) {
				// If our parent also calls "this.base()", it will refer back to us. If this happens,
				// reassign the fn context to our parent, so "this.base()" will call our parent's parent
				context = this._parent;

				// "el" is a magic property that we need to assign manually
				context.el = this.el;
			}

			// Make sure the parent has the required function
			if (context._parent && context._parent[fnName]) {
				context._lastParentContext = context;

				// Call our parent's fn using the specified context
				context._parent[fnName].call(context, fnArgs);
			}

			// Remove the special "el" property after the call has been made
			if (isLastContext) {
				context.el = null;
			}

			// Reset the last context reference
			context._lastParentContext = null;
		},

		// Remove all traces of the widget from the page (except DOM)
		dispose: function(removeFromDom) {
			var self = this;

			// Unbind all observed events
			mod.observer.unbindAll(function(fn, context) {
				return context === self;
			});

			// Remove our children
			this.el.find(".widget").each(function(i, childNode) {
				var childInstances = $(childNode).data("widget");

				if (childInstances) {
					childInstances.dispose();
				}
			});

			if (removeFromDom) {
				this.el.remove();
			}
		},

		showLoading: function() {
			this.el.addClass("loading");
		},

		hideLoading: function() {
			this.el.removeClass("loading");
		},

		getContext: function() {
			var context = {};
			var contextAttr = this.el.attr("data-context");

			if (contextAttr) {
				context = JSON.parse(contextAttr) || {};
			}

			return context;
		},

		setContext: function(key, value) {
			var newContext = {};

			// Allow the dev to pass in a full obj instead of a key/value
			if (typeof key == "object") {
				newContext = key;
			}
			else {
				newContext[key] = value;
			}

			// Combine the old and new contexts
			var combinedContext = $.extend(true, {}, this.getContext(), newContext);

			// Save off the context to the DOM
			this.el.attr("data-context", JSON.stringify(combinedContext));
		}

	};

})(jQuery, window.mod);